<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">ÜBERSICHT</h1>
    <p class="mb-8 leading-normal">Hier entsteht in Zukunft eine Übersichtsseite. Diese ist jetzt noch nicht fertig. Hier werden dann schnelle Zusammenfassungen zu sehen sein.</p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
